import { SvgIcon } from "@mui/material";
import { ReactComponent as SuggestedReviewersIcon } from "./../Icons/SuggestedReviewers.svg"
import { ReactComponent as PrintIcon } from "./../Icons/Print.svg"
import { ReactComponent as InstructionsIcon } from "./../Icons/Instructions.svg"
import { ReactComponent as ProposalDetailsIcon } from "./../Icons/ProposalDetails.svg"
import { ReactComponent as DetailedEvaluationIcon } from "./../Icons/DetailedEvaluation.svg"
import { ReactComponent as GradingIcon } from "./../Icons/Grading.svg"
import { ReactComponent as FinalRecommendationIcon } from "./../Icons/FinalRecommendation.svg"

export const SuggestedReviewers = (props) => (
  <SvgIcon {...props} component={SuggestedReviewersIcon} viewBox="0 0 17 17" />
);
export const Print = (props) => (
  <SvgIcon {...props} component={PrintIcon} viewBox="0 0 17 17" />
);
export const Instructions = (props) => (
  <SvgIcon {...props} component={InstructionsIcon} viewBox="0 0 17 17" />
);
export const Details = (props) => (
  <SvgIcon {...props} component={ProposalDetailsIcon} viewBox="0 0 25 25"/>
);
export const EvaluationDetails = (props) => (
  <SvgIcon {...props} component={DetailedEvaluationIcon} viewBox="0 0 28 28" />
);
export const Grading = (props) => (
  <SvgIcon {...props} component={GradingIcon} viewBox="0 0 25 25"/>
);
export const RecommendationIcon = (props) => (
  <SvgIcon {...props} component={FinalRecommendationIcon} viewBox="0 0 27 27"/>
);


